import TRANSLATE_MISSING from'@graphql/mutations/TranslateMissing.graphql';import{useMutationWithValidationErrors}from'./useMutationWithValidationErrors';/**
 * Starts one background translation run: everything still missing in `locale` for one target -
 * text overrides and video subtitles.
 *
 * No Apollo cache update and no `refetchQueries` on purpose. The mutation returns only
 * `enqueued`; at that moment the job has not run, so nothing about the target has changed and
 * anything refetched here would write the *old* translation statuses back into the cache -
 * making the badge look like the click did nothing.
 *
 * The refresh happens minutes later instead, when the run's notification arrives:
 * `useActionCableNotifications` refetches the active queries for a `translation_run`
 * notification. Please do not add `refetchQueries` here.
 *
 * Failures need no UI either: `customErrorHandlingLink` in `config/apolloSetup.tsx` toasts
 * `errors.fullMessages` for every mutation response that carries them, which covers the
 * server's `locale_not_enabled` refusal.
 */const useTranslateMissing=()=>useMutationWithValidationErrors(TRANSLATE_MISSING,data=>{var _data$translateMissin;return(_data$translateMissin=data.translateMissing)===null||_data$translateMissin===void 0?void 0:_data$translateMissin.errors;});export default useTranslateMissing;